import React from 'react'
import Nav from './Nav'
import Footer from './Footer'
import { Outlet } from 'react-router';
import Navbar from './Navbar';
function Container({setcontent}) {
  return (
    <>
    <div>
    <Navbar setcontent={setcontent}/>
    <Nav setcontent={setcontent}/>
   <Outlet/>
    <Footer />
    </div>
    </>
  )
}

export default Container
